module.exports = __webpack_public_path__ + "static/media/download.90078574.svg";